import { render, staticRenderFns } from "./sms-file-settings.vue?vue&type=template&id=7070ecec&scoped=true"
import script from "./sms-file-settings.vue?vue&type=script&lang=js"
export * from "./sms-file-settings.vue?vue&type=script&lang=js"
import style0 from "./sms-file-settings.vue?vue&type=style&index=0&id=7070ecec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7070ecec",
  null
  
)

export default component.exports